module.exports = __webpack_public_path__ + "fonts/malgun.3a025ae9.ttf";